import type { AssignedWorkflowPhaseDto } from './assignedWorkflow.dto';
import type { CallDto } from './call.dto';
import type { HospitalizationDto } from './hospitalizations.dto';
import type { MessageDto } from './message.dto';
import type { NoteDto } from './note.dto';
import type { ScheduledEventDto } from './scheduledEvent.dto';
import type { VisitDto } from './visit.dto';

export type TodoExternalItemTypeDto =
  | 'call'
  | 'feedback_call'
  | 'message'
  | 'visit'
  | 'note'
  | 'scheduled-event'
  | 'assigned-workflow-phase'
  | 'hospitalization'
  | 'call_audit';

export enum TodoTypeDto {
  TEXT_BACK = 'TEXT_BACK',
  CALL_BACK = 'CALL_BACK',
  FEEDBACK_CALL = 'FEEDBACK_CALL',
  HOSPITALIZATION_FOLLOW_UP = 'HOSPITALIZATION_FOLLOW_UP',
  INCOMPLETE_CALL = 'INCOMPLETE_CALL',
  INCOMPLETE_VISIT = 'INCOMPLETE_VISIT',
  INCOMPLETE_NOTE_VISIT = 'INCOMPLETE_NOTE_VISIT',
  INCOMPLETE_NOTE_CALL = 'INCOMPLETE_NOTE_CALL',
  SCHEDULED_EVENT = 'SCHEDULED_EVENT',
  SCHEDULE_WORKFLOW_PHASE_REMINDER = 'SCHEDULE_WORKFLOW_PHASE_REMINDER',
  CALL_AUDIT = 'CALL_AUDIT',
  ASSIGN_CALL = 'ASSIGN_CALL',
}
export interface TodoDto {
  id: number;
  userId: string;
  type: TodoTypeDto;
  subjectId: string;
  externalItemId: number;
  externalItemType: TodoExternalItemTypeDto;
  customTitle: string;
  date: string;
  time: number;
  completedAt: number;
  call: CallDto;
  feedbackCall: CallDto;
  message: MessageDto;
  visit: VisitDto;
  note: NoteDto;
  scheduledEvent: ScheduledEventDto;
  assignedWorkflowPhase: AssignedWorkflowPhaseDto;
  hospitalization: HospitalizationDto;
  createdAt: number;
}
